module.exports = __webpack_public_path__ + "static/media/4.4d9cfa12.png";